import { ReactNode } from "react";
import Typography from "@mui/material/Typography";

export const PageTitle = ({ children }: { children?: ReactNode }) => (
  <Typography variant="h5" sx={{ marginBottom: 2}}>
    {children}
  </Typography>
);
